import { DateTime } from "luxon";

export function formatSummaryDate(date: Date, language: string): string {
    const dateTime = DateTime.fromJSDate(date).setLocale(language);

    if (language === "fr") {
        return dateTime.toFormat("ccc d MMMM");
    }

    return dateTime.toFormat("ccc., MMM. d");
}

export function formatSummaryTime(time: string, language: string): string {
    const [hour, minute] = time.split(":").map(Number);

    if (language === "fr") {
        return time.replace(":", "h");
    }

    const hour12 = hour % 12 || 12;
    const suffix = hour < 12 ? " a.m." : " p.m.";

    return `${hour12}:${String(minute).padStart(2, "0")}${suffix}`;
}
